import { get } from '@uipath/portal-shell-util';
import jwt_decode from 'jwt-decode';

import {
    IPersonaFit,
    IWeightedPersona,
    LEFT_NAV_PERSONAS,
} from '../../models/persona';
import Logger from '../logger/logger';
import { getOrganizationStandardUrl } from '../orgStandardUrlHelper';

// TODO: Remove this after API is updated to bring the dominant personas
function getDominantPersona(fit: IWeightedPersona[]) {
    const prioritiesOrder = [
        LEFT_NAV_PERSONAS.ADMIN,
        LEFT_NAV_PERSONAS.RPA_DEVELOPER,
        LEFT_NAV_PERSONAS.CITIZEN_DEV,
        LEFT_NAV_PERSONAS.BUSINESS_ANALYST,
        LEFT_NAV_PERSONAS.BUSINESS_USER,
        LEFT_NAV_PERSONAS.AUTOMATION_EXPRESS_USER,
        LEFT_NAV_PERSONAS.TESTER,
    ];

    if (!fit || fit.length === 0) {
        return LEFT_NAV_PERSONAS.UNKNOWN;
    }

    const dominantWeight = fit[0].weight;
    const dominantPersonas = fit.filter(pers => pers.weight === dominantWeight);

    return prioritiesOrder.find(priority => (
        dominantPersonas.some(pers => pers.persona === priority)
    )) ?? LEFT_NAV_PERSONAS.UNKNOWN;
}

export async function getCurrentUserPersona(token: string): Promise<string> {
    const organizationStandardUrl = getOrganizationStandardUrl({ shouldIncludeAccountNameOnK8s: true });

    Logger.debug('persona', 'fetch');
    const data = await get<IPersonaFit>(
        `${organizationStandardUrl}/portal_/api/persona/persona/${jwt_decode<{ sub: string }>(token).sub}`,
        { token },
        (e, method, url, requestProps) => {
            Logger.warn('api', `unexpected error happened on getCurrentUserPersona API call: ${e}, ${e.stack}`, {
                object: {
                    method,
                    error: e,
                    url,
                    requestProps,
                    hasToken: !!token,
                },
                stack: e.stack,
            });
        },
    );

    const dominantPersona = getDominantPersona(data.fit);

    Logger.info('persona', 'resolved', {
        object: {
            dominantPersona,
            fromApiCall: true,
            personaFit: data,
        },
    });

    return dominantPersona;
}

